import firebaseApp from "../../../firebase/credenciales";
import { getFirestore, collection, getDocs } from "firebase/firestore";
const db = getFirestore(firebaseApp);

export default async function getProduccion_costos(Presentacion) {
    

   //console.log(Presentacion);
    const productos =  [];
    //console.log(valor);
    const collectionRef = collection(db, "Produccion/Lineas_produccion/Costos_"+Presentacion.replace(/ /g, ""));
    const snapshot = await getDocs(collectionRef);
    snapshot.forEach((doc) => {
      productos.push(doc.data());
    });
    return productos;
    

}
